import { request } from '@umijs/max';

// 查询faq配置列表
export async function queryFaqService(data: any) {
  const { pageIndex, pageCount } = data;
  return request('/bcare/faq/list/condition', {
    method: 'POST',
    data,
  }).then((res) => {
    let list: any = [];
    if (res?.faqList?.length) {
      res?.faqList.forEach((d: { subjectList: any }) => {
        list = [...list, ...d.subjectList];
      });
    }

    return {
      list,
      total: list.length,
      pageIndex: pageIndex + 1,
      pageCount,
    };
  });
}

// 查询类别信息
export async function queryCateGoryService(params: any) {
  return request(`/bcare/faq/category/list`, {
    params,
  }).then((res) =>
    res?.categoryList?.length
      ? res.categoryList.map((d: { catgName: string; faqCatgId: number }) => ({
          label: d.catgName,
          value: d.faqCatgId,
        }))
      : [],
  );
}

// 查询课题信息
export async function querySubjectService(params: any) {
  return request(`/bcare/faq/subject/list`, {
    params,
  }).then((res) =>
    res?.subjectList?.length
      ? res.subjectList.map((d: { subject: string }) => ({
          label: d.subject,
          value: d.subject,
        }))
      : [],
  );
}
